import { render, staticRenderFns } from "./DatePickerField.vue?vue&type=template&id=36ae87a8&scoped=true&"
import script from "./DatePickerField.vue?vue&type=script&lang=js&"
export * from "./DatePickerField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae87a8",
  null
  
)

export default component.exports